<template>
  <card extra-classes="bg-white px-4 pt-5 pb-8 sm:px-6">
    <h2 id="timeline-title" class="text-lg font-medium text-gray-900">Attachments</h2>
    <div v-if="pipelineReview.file_objects" class="mt-6 flow-root">
      <ul role="list" class="-mb-8">
        <li
          v-for="file of pipelineReview.file_objects"
          :key="file.name"
          class="pb-4 pl-3 pr-4 py-3 flex items-center justify-between text-sm"
        >
          <div class="w-0 flex-1 flex items-center">
            <svg
              class="flex-shrink-0 h-5 w-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="ml-2 flex-1 w-0">{{ file.name }}</span>
          </div>
          <div class="ml-4 flex-shrink-0">
            <ButtonMenu :iconOnly="true" :sections="2">
              <template v-slot:topmenu>
                <a
                  target="_blank"
                  :href="file.url"
                  class="cursor-pointer group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                  role="menuitem"
                >
                  <svg
                    class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                    />
                  </svg>
                  View
                </a>
              </template>
            </ButtonMenu>
          </div>
        </li>
      </ul>
    </div>
  </card>
</template>

<script>
import Card from '../Card/index.vue';
import ButtonMenu from '../shared/ButtonMenu.vue';

export default {
  props: ['pipelineReview'],
  components: {
    ButtonMenu,
    Card,
  },
  data() {
    return {
      files: null,
    };
  },
};
</script>
